import { useCallback } from 'react';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { FUND_TRANSFER_INTERNAL_BALANCE_TYPE } from '../constants';
import { useDynamicReducerDispatch } from '../store';
import * as actions from '../store/actions';

export const useUpdateInternalBalance = () => {
    const translate = useComponentTranslations();
    const dynamicReducerDispatch = useDynamicReducerDispatch();

    return useCallback((response) => {
        try {
            const { balances } = response.data;
            const { balance } = balances.find((_balance) => _balance.balanceType === FUND_TRANSFER_INTERNAL_BALANCE_TYPE);
            const { amount, currencyCode } = balance;

            dynamicReducerDispatch(actions.setInternalBalance({ currencyCode, amount }));
        } catch (error) {
            dynamicReducerDispatch(actions.setInternalBalance({ message: translate('balance.internal.error') }));
        }
    }, [
        translate,
        dynamicReducerDispatch
    ]);
};
